import React from "react";
// libs
import NextImage from "next/image";
// components
import Pagination from "src/components/ui/Pagination";
import { useRouter } from "next/router";

// hooks
import { useReviews } from "src/hooks/requests/reviews";

// utils
import { getTheStars } from "src/utils/reviews";
import {
  ContentWrapper,
  ReviewsWrapper,
  Title,
  ReviewCard,
  AmountOfReviews,
  StarsAndLabel,
  Stars,
  Label,
  ReviewerDetails,
  Review,
  TitleCard,
} from "./reviews.styles";

interface IReview {
  verified: boolean;
  title: string;
  rating: number;
  rateDetails: string;
  description: string;
  id: number;
  is_name_hidden: boolean;
  reviewer_name: string;
  created_at: string;
}

const ReviewsCardsContainer = ({ reviews, reviewsCount }: any) => {
  const router = useRouter();

  const ITEMS_PER_PAGE = 10;
  const startPosition = Number(router.query?.start) || 0;
  const pageItems = reviews.slice(startPosition, startPosition + ITEMS_PER_PAGE);

  return (
    <div>
      <ContentWrapper>
        <Title>Reviews</Title>
        <AmountOfReviews>{reviewsCount || 0} reviews</AmountOfReviews>

        <ReviewsWrapper>
          {pageItems.map((reviewItem: IReview, index: number) => {
            const reviewerName = reviewItem.is_name_hidden
              ? "Anonymous"
              : reviewItem.reviewer_name
              ? reviewItem.reviewer_name
              : "Anonymous";
            const createdAtDate = new Date(reviewItem.created_at);
            // eslint-disable-next-line max-len
            const createdAt = `${createdAtDate.getDate()}/${createdAtDate.getMonth()}/${createdAtDate.getFullYear()}`;
            return (
              <ReviewCard key={`${reviewItem.id + index}`}>
                <TitleCard>{reviewItem.title}</TitleCard>
                <StarsAndLabel>
                  <Stars>
                    {getTheStars(reviewItem.rating).map((starSrc, idx) => (
                      <NextImage key={idx} src={starSrc} width={15} height={15} />
                    ))}
                  </Stars>
                  {false ? <Label>Verified</Label> : null}
                </StarsAndLabel>
                <ReviewerDetails>
                  {`${reviewerName},`} {createdAt}
                </ReviewerDetails>
                <Review>{reviewItem.description}</Review>
              </ReviewCard>
            );
          })}
        </ReviewsWrapper>

        <Pagination totalCount={reviewsCount} />
      </ContentWrapper>
    </div>
  );
};

export default ReviewsCardsContainer;
